import { jsx, jsxs } from 'react/jsx-runtime';
import { createPortal } from 'react-dom';
import ReactFocusLock from 'react-focus-lock';
import '../Transition/ZoomTransition/ZoomTransition.js';
import '../Transition/SlideInUpTransition/SlideInUpTransition.js';
import { OpacityTransition } from '../Transition/OpacityTransition/OpacityTransition.js';
import { useElementById } from '../../utils/hooks/useElementById/useElementById.js';
import { ShadowDOM } from '../ShadowDOM/ShadowDOM.js';
import { useViewContext } from '../../context/ViewContext/ViewContext.js';
import { useKeyboardEventListener } from '../../utils/hooks/useKeyboardEventListener/useKeyboardEventListener.js';

const ModalComponent = ({ children, handleClose, withBackdrop = true, zIndex, whiteList, }) => {
    const { view } = useViewContext();
    const shouldCloseOnBackdropClick = view !== 'collect-user-data' &&
        view !== 'network-not-supported' &&
        view !== 'update-email' &&
        view !== 'login-with-email-verification' &&
        view !== 'verify-email';
    const handleKeyClose = (event) => {
        if (!shouldCloseOnBackdropClick)
            return;
        if (event.key === 'Escape')
            handleClose();
    };
    const onBackdropClick = (e) => {
        if (!shouldCloseOnBackdropClick)
            return;
        e.stopPropagation();
        handleClose();
    };
    useKeyboardEventListener({
        disabled: !shouldCloseOnBackdropClick,
        inputKey: 'Escape',
        onKeyPressed: handleClose,
    });
    return (jsxs(ReactFocusLock, Object.assign({ className: 'modal__container', whiteList: whiteList }, { children: [withBackdrop && (jsx("div", { "data-testid": 'portal-backdrop', role: 'button', onClick: (e) => {
                    onBackdropClick(e);
                }, onKeyDown: handleKeyClose, tabIndex: 0, "aria-label": 'Close modal', 
                // z-index - 2 to ensure that the backdrop is always behind the content
                style: { zIndex: zIndex ? zIndex - 2 : undefined }, className: 'modal__backdrop' })), jsx("div", Object.assign({ className: 'modal', style: { zIndex } }, { children: children }))] })));
};
const Portal = ({ children, isShown, handleClose, withBackdrop, zIndex, transitionEvents, elementId = 'dynamic-modal', }) => {
    const modalRootElementRef = useElementById(elementId);
    return createPortal(jsx(ShadowDOM, Object.assign({ zIndex: zIndex, dataTestId: 'dynamic-modal-shadow' }, { children: jsx(OpacityTransition, Object.assign({ isShown: isShown }, transitionEvents, { children: jsx(ModalComponent, Object.assign({ handleClose: handleClose, withBackdrop: withBackdrop, whiteList: (node) => modalRootElementRef.current.contains(node) }, { children: children })) })) })), modalRootElementRef.current);
};

export { Portal };
